let _ = t => t,
  _t;
import { useCallback, useRef } from 'react';
import styledWithTheme from 'foundations-theming/utils';
import { useObserveTableElementRef } from '../../virtualization/hooks/useObserveTableElementRef';
import { useColumnDragAndDrop } from '../../reordering/useColumnDragAndDrop';
import { COLUMN } from '../../virtualization/types/observerTypes';
import ContentComponentInner from './ContentComponentInner';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDropTarget = styledWithTheme.div(_t || (_t = _`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  border-width: ${0};
  border-style: dashed;
  border-radius: ${0};
  border-color: ${0};

`), ({
  theme
}) => theme.borderWidth[200], ({
  theme
}) => theme.borderRadius[300], ({
  theme,
  $isActiveDropTarget
}) => $isActiveDropTarget ? theme.color['border-core-hover'] : `transparent`);

/** This component is what is passed to UITable's `Content` prop, and internally implements column header drag and drop, and resizing
 * ResizableSortTH
 *   getContentComponent
 *     DraggableResizableHeaderContent
 *       Children
 *       ContentComponentInner
 *         ContextMenuHeaderTriggerButton
 *         ResizeAffordance
 */
export const DraggableResizableHeaderContent = ({
  arrowsNode,
  children,
  columnIndex,
  columnName,
  columnNamespace,
  reorderable,
  onColumnOrderChange,
  handleResize,
  originalWidth,
  onResizeEnd,
  resizable
}) => {
  const initialXRef = useRef(0);
  const handleObserveRef = useObserveTableElementRef();
  const {
    onDragStart,
    onDragEnter,
    onDragLeave,
    onDrop,
    onDragOver,
    onDrag,
    isActiveDropTarget
  } = useColumnDragAndDrop({
    columnName,
    columnNamespace,
    columnIndex,
    onColumnOrderChange,
    reorderable
  });
  const handleMouseDown = useCallback(initiatingEvent => {
    initialXRef.current = initiatingEvent.clientX;

    // Prevent the initiating event from sorting or dragging
    initiatingEvent.preventDefault();
    const handleMouseMove = ({
      clientX
    }) => handleResize(originalWidth + (clientX - initialXRef.current));
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', event => {
      // Prevent the terminating event from sorting
      event.preventDefault();
      document.removeEventListener('mousemove', handleMouseMove);
      onResizeEnd();
    }, {
      once: true
    });
  }, [handleResize, onResizeEnd, originalWidth]);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledDropTarget, Object.assign({
      $isActiveDropTarget: isActiveDropTarget
    }, reorderable && {
      'data-test-id': `drag-header-${columnNamespace}-${columnName}`
    }, {
      ref: handleObserveRef,
      "data-observer-type": COLUMN,
      "data-observer-id": columnIndex,
      draggable: reorderable,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onDragEnter: onDragEnter,
      onDragLeave: onDragLeave,
      onDragOver: onDragOver,
      onDrag: onDrag,
      children: /*#__PURE__*/_jsx(ContentComponentInner, {
        arrowsNode: arrowsNode,
        columnName: columnName,
        columnNamespace: columnNamespace,
        onMouseDown: handleMouseDown,
        resizable: resizable,
        reorderable: reorderable,
        children: children
      })
    }))
  );
};